<template>
  <div class="checkout-view">
    <div class="checkout-content">
      <div class="product-container">
        <div class="product-title">
          <div class="product-title-content" :style="{'backgroundImage': `url(${stockBG})`}">
            <div class="image-container">
              <img class="merchant-image" :src="mmlogo" />
            </div>
          </div>
        </div>
        <div class="product">
          <div class="product-description">
            <div class="product-wrapper">
              <img class="product-image" :src="stocks">
              <div class="product-name">
                <span>
                  Premium Group Access
                </span>
              </div>
            </div>
          </div>
          <div class="price">
            <div class="price-wrapper">
              <div class="price-title">
                <span>
                  Price:
                </span>
              </div>
              <div class="price-value">
                <span>
                  Free Month From Options Domination Purchase 
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="paypal-container">
        <div ref="paypal"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mmlogo from '../assets/images/mmlogo.png';
import stocks from '../assets/images/stocks.png';
import stockBG from '../assets/images/stock-bg.jpg';

export default {
  name: 'Trial',
  metaInfo: {
    title: 'Market Moves - Trial',
    titleTemplate: 'Trial'
  },
  data() {
    return {
      loaded: false,
      mmlogo,
      stocks,
      stockBG
    }
  },
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://www.paypal.com/sdk/js?client-id=AXp6ZVWmhJAJ91mwnutL3qT4rVnhtpJ37y9LbTnGkWGsx9e-7gLkwhkPEaeNn2FAcgk1sINYNeuNfv0n&currency=USD&vault=true&disable-funding=card';
    script.addEventListener('load', this.setLoaded);
    document.body.appendChild(script);
  },
  methods: {
    setLoaded: function() {
      this.loaded = true;
      window.paypal.Buttons({
        createSubscription: function(data, actions) {
          return actions.subscription.create({
            'plan_id': 'P-0JG31604SJ8244028L4DVESQ'
          });
        },
        // eslint-disable-next-line no-unused-vars
        onApprove: async function(data, actions) {
          window.location.replace('https://market-moves.web.app/confirmation')
        },
        onError: err => {
          console.log(err);
        },
        style: {
          shape: 'rect',
          height: 40,
          label: 'pay',
          color: 'silver'
        }
      })
      .render(this.$refs.paypal);
    }
  },
  setPaid: function() {
    this.paid = true;
  }
}
</script>

<style scoped>
  .checkout-view {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    height: 300px;
    width: 400px;
    background-color: #36393f;
    color: #f8f8f8;
    font-size: 14px;
    border-radius: 8px;
    margin: 0 auto;
    box-shadow: 1px 1px 0px #282b2f,
                2px 2px 0px #2f3033,
                3px 3px 0px #282b2f,
                4px 4px 0px #2f3033,
                5px 5px 0px #282b2f,
                6px 6px 0px #2f3033;
  }

  .checkout-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .product-container {
    height: 60%;
  }

  .product-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-title-content {
    border-radius: 8px;
    height: 80%;
    width: 90%;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .product {
    height: 50%;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #59595e;
  }

  .product-description {
    height: 100%;
    width: 100%;
    padding-top: 10px;
  }

  .product-wrapper {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 15px;
  }

  .product-image {
    height: 40px;
    width: 40px;
    padding-right: 5px;
  }

  .product-name {
    padding-left: 5px;
  }


  .paypal-container {
    height: 40%;
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;
  }

  .image-container {
    height: 120px;
    width: 120px;
    margin: 0 auto;
    display: flex;
  }

  .merchant-image {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }

  .price {
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    padding-left: 10px;
    padding-bottom: 20px;
  }

  .price-wrapper {
    display: flex;

  }

  .price-title {
    padding-right: 5px;
  }

  .price-value {
    padding-left: 5px;
  }

  .paid-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .checkmark-container {
    height: 80px;
    width: 80px;
  }

  .checkmark-container img {
    height: 100%;
    width: 100%;
  }

  .paid-content__1 {
    padding: 10px 0 0 0;
  }

  .paid-content__2 {
    padding: 10px 40px 0 40px;
  }

  .paid-content__3 {
    padding: 30px 40px 0 40px;
  }

  .paid-content__4 {
    padding: 5px 40px 0 40px;
  }

</style>
